import DataWorker from './computedAllData.worker';
import type StandardChart from '../../core/StandardChart';
import { type Option } from '../../core/option';
import {
  handleDynamicRenderItem,
  handleDynamicRenderItemText,
  handleDynamicRenderItemCircle,
  handleDynamicRenderItemCircleText
} from '../voronoi';

type customObject = Record<string, any>;
type DataIndex = number;
let lastIndex: number = null;

interface DataItem {
  data: Array<Array<customObject>>;
  link: Array<Array<customObject>>;
  info: Array<customObject>;
}

export class DynamicVoronoiHelper {
  private _chart: StandardChart;

  private _data: DataItem;

  private _option: Option;

  private _index: DataIndex;

  private _arg: any;

  private _dataIndexArray: any;

  private _handleData: any;

  private _handleSiteData: any;

  private _singleData: any;

  private _dataFilterSingle: any;

  private _singleDataIndex: Array<number>;

  private _callback: any;
  constructor(chart: StandardChart, option: Option, data: DataItem, arg: any, callback: any) {
    this._chart = chart;
    this._data = data;
    this._option = option;
    this._index = data.length - 1;
    this._arg = arg;
    this._dataIndexArray = [];
    this._handleData = [];
    this._handleSiteData = [];
    this._callback = callback;
    this._singleData = [];
    this._singleDataIndex = [];
    this._dataFilterSingle = [];
  }

  private init() {
    this.handleAllData();
    // 这里的数据要处理一下，要点：
    // 拿到全量数据，拿到所有index，去重组装成一组数据data1
    // data1 [{index:0},{index:1},{index:2},{index:3},{index:4}]
    // 拿到当前this.index的数据，根据长度替换掉data1的前部分，假如this.index数组长度为4，索引为4时，元素index为5，那么要把data1中的index等于5替换成4
    // this.index [{index:0},{index:1}{index:4}]  ===>  data1 [{index:0},{index:1},{index:4},{index:3},{index:2}]
    let newDataArray = [];
    this._data.forEach(element => {
      const newData = JSON.parse(
        JSON.stringify(
          element.map(item => {
            return { ids: item.ids };
          })
        )
      );
      this._dataIndexArray.map((item, index) => {
        if (element.findIndex(target => target.ids === item.ids) === -1) {
          newData.push({ ids: item.ids });
        }
      });
      if (element.length !== 1) {
        newDataArray.push(newData);
      }
    });
    this._option.series[0].data = this._data[this._index];
    this._option.series[1].data = this._data[this._index];
    // 过滤掉周期数据只存在一个的数据（d3-voronoi-map-tween依赖的d3-weighted-voronoi插件不支持单个数据权重计算）
    this._singleData = this._data.filter(item => item.length === 1);
    this._data.map((item, index) => {
      if (item.length === 1) {
        this._singleDataIndex.push(index);
      }
    });
    this._dataFilterSingle = this._data.filter(item => item.length > 1);
    if (this._handleData.length === 0) {
      if (this._dataFilterSingle.length !== 0) {
        const dataWorker = new DataWorker();
        const workerData = {
          data: this._dataFilterSingle,
          optionData: newDataArray,
          radius: this._option.series[0].dvRadius
        };
        dataWorker.postMessage(JSON.stringify(workerData));
        dataWorker.onmessage = event => {
          this._callback();
          let handleData = JSON.parse(event.data);
          this._handleSiteData = handleData[handleData.length - 1];
          this._singleDataIndex.forEach((item, index) => {
            handleData.splice(item, 0, this._singleData[index]);
            this._handleSiteData.splice(item, 0, this._singleData[index]);
          });
          this._handleData = handleData.slice(0, handleData.length - 1);
          if (this._singleDataIndex.indexOf(this._index) === -1) {
            this._option.series[0].renderItem = handleDynamicRenderItem(
              this._handleData[this._index],
              this._handleSiteData[this._index]
            );
            this._option.series[1].renderItem = handleDynamicRenderItemText(
              this._handleData[this._index],
              this._handleSiteData[this._index],
              this._arg
            );
          } else {
            this._option.series[0].renderItem = handleDynamicRenderItemCircle(
              this._data[this._index],
              this._option.series[0].dvRadius
            );
            this._option.series[1].renderItem = handleDynamicRenderItemCircleText(
              this._data[this._index],
              this._arg
            );
          }
          const option = this._option;
          this._chart.play({
            option
          });
          lastIndex = this._index;
        };
      } else {
        this._option.series[0].renderItem = handleDynamicRenderItemCircle(
          this._data[this._index],
          this._option.series[0].dvRadius
        );
        this._option.series[1].renderItem = handleDynamicRenderItemCircleText(
          this._data[this._index],
          this._arg
        );
        const option = this._option;
        this._chart.play({
          option
        });
        lastIndex = this._index;
      }
    } else {
      if (this._dataFilterSingle.length !== 0) {
        if (this._singleDataIndex.indexOf(this._index) === -1) {
          this._option.series[0].renderItem = handleDynamicRenderItem(
            this._handleData[this._index],
            this._handleSiteData[this._index]
          );
          this._option.series[1].renderItem = handleDynamicRenderItemText(
            this._handleData[this._index],
            this._handleSiteData[this._index],
            this._arg
          );
        } else {
          this._option.series[0].renderItem = handleDynamicRenderItemCircle(
            this._data[this._index],
            this._option.series[0].dvRadius
          );
          this._option.series[1].renderItem = handleDynamicRenderItemCircleText(
            this._data[this._index],
            this._arg
          );
        }
      } else {
        this._option.series[0].renderItem = handleDynamicRenderItemCircle(
          this._data[this._index],
          this._option.series[0].dvRadius
        );
        this._option.series[1].renderItem = handleDynamicRenderItemCircleText(
          this._data[this._index],
          this._arg
        );
      }
      const option = this._option;
      this._chart.play({
        option
      });
      lastIndex = this._index;
    }
  }

  handleAllData() {
    // 根据ids大小排序
    this._data = this._data.map(item => {
      item.sort(function (a, b) {
        if (a.ids < b.ids) {
          return -1;
        }
        if (a.ids > b.ids) {
          return 1;
        }
        return 0;
      });
      return item;
    });
    // 获取全周期的种类并根据ids大小排序
    this._dataIndexArray = [];
    this._data.map(item => {
      item.map(ele => {
        if (this._dataIndexArray.findIndex(target => target.ids === ele.ids) === -1) {
          this._dataIndexArray.push(ele);
        }
      });
    });
    this._dataIndexArray = this._dataIndexArray.sort(function (a, b) {
      if (a.ids < b.ids) {
        return -1;
      }
      if (a.ids > b.ids) {
        return 1;
      }
      return 0;
    });
  }

  play(index?: number) {
    // 记录上一次的数据索引
    this._index = index === 0 || index ? index : this._index;
    lastIndex === null && (lastIndex = this._index);
    this.init();
  }
}
